module.exports = __webpack_public_path__ + "static/media/Niveau_elN15_4_668229.026bd746.png";